// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "52e06790d87b99d384c50df67e604600dbf3b6f3/static/css/" + chunkId + "." + {"252":"ddced95f","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};